module.exports = __webpack_public_path__ + "assets/chine_2_0-069c939074f956336487f06487dca362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/chine_2_0.jpg
// module id = 509
// module chunks = 1